import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[BaseOnlynumeric]',
    standalone: false
})
export class OnlynumericDirective {

  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    let permitidos = '0123456789';
    if (!permitidos.includes(event.key) && event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
      event.preventDefault();
    }
  }
}
